import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('tuki_user');
    if (stored) setUser(JSON.parse(stored));
    setLoading(false);
  }, []);

  const getTheme = (businessType) => {
    if (!businessType) return 'barberia';
    const t = businessType.toLowerCase();
    if (t.includes('est') || t.includes('spa') || t.includes('bell')) return 'estetica';
    return 'barberia';
  };

  const loginBusiness = async (username) => {
    const res = await api.post(`/business/login?username=${encodeURIComponent(username)}`);
    // Use theme stored in DB; fallback to type-based logic
    const theme = res.data.theme || getTheme(res.data.business_type);
    const userData = { ...res.data, role: 'business', theme };
    setUser(userData);
    localStorage.setItem('tuki_user', JSON.stringify(userData));
    return userData;
  };

  const loginAdmin = async (email, password) => {
    const res = await api.post('/admin/login', { email, password });
    const userData = { ...res.data, role: 'admin', theme: 'barberia' };
    setUser(userData);
    localStorage.setItem('tuki_user', JSON.stringify(userData));
    return userData;
  };

  const updateUser = (updates) => {
    setUser(prev => {
      const updated = { ...prev, ...updates };
      localStorage.setItem('tuki_user', JSON.stringify(updated));
      return updated;
    });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('tuki_user');
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginBusiness, loginAdmin, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
